import { ABOUT_IMAGE } from "../assets";

export default function About() {
  return (
    <section
      id="nosotros"
      data-testid="about-section"
      className="nr-section nr-bg-soft"
    >
      <div className="nr-container grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <div className="rounded-3xl overflow-hidden border border-[#EAEAEA]">
            <img
              src={ABOUT_IMAGE}
              alt="Equipo THE NEXT ROOM"
              className="w-full h-[520px] object-cover"
            />
          </div>
        </div>

        <div className="lg:col-span-6">
          <span className="nr-eyebrow">Sobre THE NEXT ROOM</span>
          <h2 className="nr-h2 mt-4">
            Un operador profesional, no una inmobiliaria más.
          </h2>
          <p className="mt-6 text-[16px] nr-text-soft leading-relaxed">
            THE NEXT ROOM nació para resolver un problema real: alquilar tu vivienda
            con el modelo tradicional implica asumir el riesgo de impago, lidiar
            con inquilinos y pagar tú las reformas.
          </p>
          <p className="mt-4 text-[16px] nr-text-soft leading-relaxed">
            Nuestra solución es simple. Nos convertimos en tu inquilino,
            reformamos cuando es necesario y gestionamos la vivienda como un
            activo profesional, para que tú cobres puntualmente cada mes y
            recuperes tu tiempo y tranquilidad.
          </p>

          <div className="mt-10 grid grid-cols-2 gap-8 pt-8 border-t border-[#EAEAEA]">
            <div>
              <div className="nr-step-num">Misión</div>
              <p className="mt-2 text-[14px] nr-text-soft leading-relaxed">
                Que ningún propietario vuelva a perder noches de sueño por su
                vivienda.
              </p>
            </div>
            <div>
              <div className="nr-step-num">Visión</div>
              <p className="mt-2 text-[14px] nr-text-soft leading-relaxed">
                Ser el operador residencial de referencia para propietarios que
                valoran la tranquilidad por encima de todo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
